import { css, keyframes } from 'styled-components';

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const rotate360Animation = css`
  animation: ${rotate360} 2s linear infinite;
`;

export { rotate360Animation };
